export default __webpack_public_path__ + "static/media/Icon=Subtasks.971fc72f.svg";